import React from 'react'


const Password = ({value}) => {
    return "Change Password"
}

export default Password